import { Icon, IconKebab } from '@flixbus/honeycomb-icons-react';
import { Button, Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import AnchoredPortalLayer from 'common/AnchoredPortalLayer';

import { useActionMenu } from './useActionMenu';

import styles from './styles.module.css';

// ! TODO: Once honeycomb is upgraded to 16+ and `useActionMenu` is replaced with honeycomb's `useSmartPosition`,
// ! remove the AnchoredPortalLayer wrapper below and let the Dropdown position itself.
const ActionMenu = ({ items = [], isLoading, onOpenChange }) => {
	const { isOpen, triggerRef, toggleMenu, handleActionClick, closeMenu } = useActionMenu({
		onOpenChange,
	});

	if (!items || items.length === 0) return null;

	const actionItems = items.map((item, index) => (
		<DropdownItem
			key={`action-${item.label}${index}`}
			Elem="button"
			disabled={isLoading}
			onClick={() => handleActionClick(item.action)}
		>
			{item.label}
		</DropdownItem>
	));

	return (
		<div ref={triggerRef} onClick={(e) => e.stopPropagation()} className={styles.menu}>
			<Button
				appearance="link"
				display="square"
				title="Actions"
				aria-label="Actions"
				aria-haspopup="menu"
				aria-expanded={isOpen}
				loading={isLoading}
				onClick={toggleMenu}
			>
				{!isLoading && <Icon InlineIcon={IconKebab} />}
			</Button>
			<AnchoredPortalLayer
				anchorRef={triggerRef}
				isOpen={isOpen}
				className={styles.portal}
				measureSelector="[class*='hcr-dropdown__items']"
				onClick={(e) => e.stopPropagation()}
				onClose={closeMenu}
			>
				<Dropdown active xPosition="left" yPosition="bottom" links={actionItems}>
					<span aria-hidden className={styles.anchor} />
				</Dropdown>
			</AnchoredPortalLayer>
		</div>
	);
};

export default ActionMenu;
